import { AuthStorage } from "utils/auth-storage";
import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Select, Button } from "antd";
import { WarehouseServices } from "apis/Services/WarehouseService";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { CompanyAdminServices } from "apis/Services/CompanyAdminService";

const PostToProcoreModal = ({
  record,
  isPostToProcoreVisible,
  setIsPostToProcoreVisible,
  materialsOptions = [],
  setShouldReload = () => {},
  isProcLog = false,
  projectID = false,
  editMode = false,
  projectDetails,
  getData,
}) => {
  const [form] = Form.useForm();
  const { company_id } = useParams();
  const [projects, setProjects] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const alignedData = projectDetails?.viewsInfo?.alignedData;

  // Extract items when modal opens
  useEffect(() => {
    if (isPostToProcoreVisible && isProcLog && projectDetails?.content) {
      const entryIDs = Object.keys(record).filter((entryID) => record[entryID]);
      const newSelectedItems = [];

      for (const key of Object.keys(projectDetails.content)) {
        const division = projectDetails.content[key];
        const subDivisions = Object.values(division);
        subDivisions.forEach((subDivision) => {
          subDivision.forEach((item) => {
            if (entryIDs.includes(item.entryID)) {
              newSelectedItems.push({
                id: item.entryID,
                submittalNumber: item.specNumber,
                submittalRevision: item.specRevision,
                submittalTitle: item.specTitle,
              });
            }
          });
        });
      }

      setSelectedItems(newSelectedItems);

      // Log the extracted items for debugging
      console.log("Extracted selectedItems:", newSelectedItems);
    }
  }, [isPostToProcoreVisible, isProcLog, record, projectDetails]);

  useEffect(() => {
    if (selectedItems.length > 0 && selectedItems[0]?.submittalTitle) {
      form.setFieldsValue({
        title: selectedItems[0].submittalTitle,
        project: projectID,
      });
    }
  }, [selectedItems, form]);

  // const procoreProjects =
  //   projects?.filter((project) => project.source === "Procore") || [];

  useEffect(() => {
    if (projects.length === 0) {
      console.log("entered?");

      let code = AuthStorage.getItem("token");
      let email = AuthStorage.getItem("email");
      let ReqObj = {
        company_id: company_id,
        code,
        loginEmail: email,
      };
      CompanyAdminServices.readRegisteredProjects(ReqObj)
        .then((res) => {
          console.log(res.content, "RESPONSEEE");
          setProjects(res.content || []);
        })
        .catch((err) => {
          console.log(err);
          setProjects([]); // Set empty array on error
        });
    }
  }, []);

  useEffect(() => {
    if (!record) {
      form.resetFields();
    } else {
      if (editMode && record) {
        console.log(record, "!!!????");

        form.setFieldsValue({
          title: record.title,
          project: projectID,
          accountingMethod: record.accounting_method,
        });
      } else {
        form.setFieldsValue({
          project: undefined, // Reset project field
          title: "",
          accountingMethod: undefined,
        });
      }
    }
  }, [record, form]);

  const onSubmit = (values) => {
    // Find the selected project using the project ID from form values
    const toastId = toast.loading("Creating purchase order...");

    const selectedProject = projects.find(
      (p) => p.projectInfo?.projectID === values.project
    );

    const Values = {
      title: values.title,
      itemID:
        selectedItems.length > 0 ? selectedItems[0].id : record?.itemID || null,
      accountingMethod: values.accountingMethod,
      contractNumber: record?.number || null,
      poStatus: "Draft",
    };

    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      projectID: selectedProject?.projectInfo?.projectID,
      purchaseOrderID: record?.purchaseOrderID || null,
      code,
      loginEmail: email,
      Values: [{ ...Values }],
    };

    console.log(ReqObj, "!!!!");
    setIsPostToProcoreVisible(false);

    if (editMode) {
      WarehouseServices.updatePurchaseOrderInProcore(ReqObj)
        .then((res) => {
          toast.success("Purchase order updated successfully", { id: toastId });
          if (!isProcLog || !editMode) {
            setShouldReload(true);
          } else if (editMode) {
            getData();
          }
          form.resetFields();
        })
        .catch((err) => {
          console.log(err);
          toast.error("Something went wrong, please try again.", {
            id: toastId,
          });
        });
    } else {
      WarehouseServices.postPurchaseOrderToProcore(ReqObj)
        .then((res) => {
          toast.success("Purchase order created successfully", { id: toastId });
          if (!isProcLog) {
            setShouldReload(true);
          }
          form.resetFields();
        })
        .catch((err) => {
          console.log(err);
          toast.error("Something went wrong, please try again.", {
            id: toastId,
          });
        });
    }
  };

  const onCancel = () => {
    setIsPostToProcoreVisible(false);
    if (!editMode) {
      form.resetFields();
    }
  };

  const handleFinish = (values) => {
    onSubmit(values);
  };

  const accountingMethodOptions = [
    { label: "Amount", value: "amount" },
    { label: "Unit", value: "unit" },
  ];

  return (
    <Modal
      title="Create Purchase Order"
      open={isPostToProcoreVisible}
      centered
      onCancel={onCancel}
      width={500}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={() => {
            form.submit();
          }}
        >
          {editMode ? "Update purchase order" : "Create purchase order"}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          label="Select a Project"
          name="project"
          rules={[{ required: true, message: "Please select a project" }]}
        >
          <Select
            placeholder="Select a project"
            options={projects.map((project) => ({
              label: `${
                project.projectInfo["Project Name"] || "Unnamed Project"
              }`,
              value: project.projectInfo.projectID,
            }))}
            disabled={isProcLog || editMode}
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>

        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: "Please enter a title" }]}
        >
          <Input
            placeholder="Enter title"
            defaultValue={selectedItems?.[0]?.submittalTitle}
          />
        </Form.Item>

        <Form.Item
          label="Accounting Method"
          name="accountingMethod"
          rules={[
            { required: true, message: "Please select accounting method" },
          ]}
        >
          <Select
            placeholder="Select accounting method"
            options={accountingMethodOptions}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PostToProcoreModal;
